import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '../../..';
import { FontColorType } from '../../../../helpers';
import { useThemeValues } from '../../../../hooks';

type Props = {
  color?: FontColorType;
  TrailingIcon?: React.ReactElement;
  children: React.ReactNode;
  isBold?: boolean;
  as?: React.ElementType;
  isCompactMode?: boolean;
};

export const ListRowTitle = ({
  color = 'default',
  TrailingIcon,
  children,
  isBold = true,
  as = Text,
  isCompactMode,
  ...rest
}: Props) => {
  const { spacing } = useThemeValues();
  const Component = as;

  return (
    <div
      css={css`
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline;
        white-space: nowrap;
        /* color for ellipsis should match color of text */
        color: ${color};
      `}
      className='content-column-title-container'
    >
      <Component
        size='large'
        weight={isBold ? 'bold' : 'inherit'}
        color={color}
        className='content-column-title'
        css={css`
          display: inline;
          line-height: 1;
          font-size: ${isCompactMode ? theme.fontSize(14) : theme.fontSize(16)};
          padding-right: ${spacing(1)};
        `}
        {...rest}
      >
        {children}
      </Component>
      {!!TrailingIcon && TrailingIcon}
    </div>
  );
};
